
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearOrdersList, getMyOrdersListings } from "../../../../redux/reducers/myOrdersSlice";
import { getPriceFormatted } from "../../../../utils/getPriceFormatted";
import { getDateValue } from "../../../../utils/getDate";
import { makePaymentForOrder } from "../../../../services/api/paymentApi";

const OrderList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const { myOrdersList, currentpage, dataPerPage, dataCount } = useSelector((state) => state.orders)


  //   {
  //     name: "Regular Cleaning",
  //     id: "Order ID: #2309-12345",
  //     hours: "12 Sessions, 4 hours",
  //     price: "400",
  //     date: "Order Date: 15 Aug 2023, 05:54",
  //     status: "PAID",
  //   },
  //   {
  //     name: "Regular Cleaning",
  //     id: "Order ID: #2309-12345",
  //     hours: "12 Sessions, 4 hours",
  //     price: "400",
  //     date: "Order Date: 15 Aug 2023, 05:54",
  //     status: "PAID",
  //   },
  //   {
  //     name: "Regular Cleaning",
  //     id: "Order ID: #2309-12345",
  //     hours: "12 Sessions, 4 hours",
  //     price: "400",
  //     date: "Order Date: 15 Aug 2023, 05:54",
  //     status: "PAID",
  //   },
  //   {
  //     name: "Regular Cleaning",
  //     id: "Order ID: #2309-12345",
  //     hours: "12 Sessions, 4 hours",
  //     price: "400",
  //     date: "Order Date: 15 Aug 2023, 05:54",
  //     status: "PENDING",
  //   },
  // ];
  useEffect(() => {
    let bodyData = {
      currentpage: 1,
      limit: dataPerPage
    }
    dispatch(getMyOrdersListings(bodyData))
    return () => dispatch(clearOrdersList())
  }, [])
  const loadMoreData = () => {
    let bodyData = {
      currentpage: currentpage + 1,
      limit: dataPerPage
    }
    dispatch(getMyOrdersListings(bodyData))
  }
  const gotoOrderDetailsPage = (val) => {
    // if (val?.isAddOnOrder) {
    //   dispatch(clearOrdersList())

    //   navigate(`/order-details/${val?.parentOrder}`)
    // }
    // else {
    //   dispatch(clearOrdersList())

    //   navigate(`/order-details/${val?._id}`)
    // }
    dispatch(clearOrdersList())
    navigate(`/order-details/${val?._id}`)
  
    

  }
  const handlePayment = async (e, item) => {
    e.stopPropagation()
    let bodyData = {
      amount: item?.invoiceAmount,
      description: "",
      redirect_url: `${window.location.origin}/order-details/${item?._id}`,
      email: item?.email,
      customerUserId: item?.userId,
      order_id: item?._id,
      paymentType: "Immediate Payment",
    };
    let payment = await makePaymentForOrder(bodyData);
  }
  return (
    <>
      <div className="upcoming-box-row oder-main">
        {myOrdersList && myOrdersList?.length > 0 ? myOrdersList.map((value, index) => {
          console.log(value);
          return (
            <div
              className="upcoming-box-col order-list justify-content-between
            align-items-center"
              onClick={() => gotoOrderDetailsPage(value)}
              key={value.name}
            >
              <div className="d-flex upfbox align-items-center justify-content-between">
                <div className="order-left">
                  <p> {value?.orderId}</p>

                  <h1>{`${value?.orderType?.charAt(0).toUpperCase()}${value?.orderType?.slice(1)} Cleaning`}</h1>
                  <div className="ses-hour">{value?.sessions ? value?.sessions === 1 ? `${value?.sessions} Session` : `${value?.sessions} Sessions` : null}{(value?.orderType === "General" || value?.orderType === "Regular") ? `, ${value?.serviceArray[0]?.duration} hours` : null} </div>
                </div>
                <div className="order-price"> ${getPriceFormatted(value?.orderAmount)}</div>
              </div>

              <div className="order-right">
                {(value?.status == "Unpaid" || value?.status == "Pending") ? (
                  <>
                    <div className="up-green up-yellow">
                      <p className="mb-0"> {value.status}</p>
                    </div>
                    {(value.createdBy === value.userId && value.status === 'Unpaid' && ((value.orderType.toLowerCase() !== 'general' && value.orderType.toLowerCase() !== 'regular' ? value.confirmProfessionalOrder : true))) && <p className="pay-btn" onClick={(e) => handlePayment(e, value)}>Pay</p>}
                  </>
                ) : (
                  <div className=" up-green">
                    <p className="mb-0"> {value.status}</p>
                  </div>
                )}

                <div className="id-with-date">{getDateValue(value?.createdAt)}</div>
              </div>
            </div>
          );
        }) : <div>No orders</div>}
        {myOrdersList && myOrdersList?.length > 0 && myOrdersList?.length !== dataCount && <div className="load-upcoming text-center cursor-pointer mb-4" onClick={() => loadMoreData()}>
          View more Orders
          <img src="/assets/images/black-arrow.png" alt="" />
        </div>}
      </div>
    </>
  );
};

export default OrderList;
